/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import { getDemandVsTimeById } from '../../../Service/APIService';
import CustomWidget from '../../Custom/CustomWidget';
import { compact, mean } from 'lodash';
import HighChartCustomGraph from '../../Custom/HighChartCustomGraph';
import { constants } from '../../../shared/constants';
import chartOptions from '../../../utils/chartsUtil';

let chart;
const DemandVsTime = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [mape, setMape] = useState('');
  const [chartObj, setChartObj] = useState({});

  useEffect(() => {
    fetchData(props.id, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  const parseData = async (data) => {
    const actual = [];
    const forecast = [];
    const mape = [];
    const mapeToDateMapping = [];
    if (data && data.length > 0) {
      data.forEach(async (element) => {
        const tmstmp = Date.parse(element.Dt.replace('_', ' '));
        actual.push([
          tmstmp,
          element.actual ? parseFloat(element.actual) : null,
        ]);
        forecast.push([
          tmstmp,
          element.forecast ? parseFloat(element.forecast) : null,
        ]);
        mape.push(element.mape);
        mapeToDateMapping.push({ time: tmstmp, mapeVal: element.mape });
      });
    }
    return { actual, forecast, mape, mapeToDateMapping };
  };

  const fetchData = async (deviceId, NumberOfMonths) => {
    try {
      const response = await getDemandVsTimeById(deviceId, NumberOfMonths);
      const { actual, forecast, mape, mapeToDateMapping } = await parseData(
        response.data.result?.forecastData
      );
      plotGraph({ actual, forecast, mape, mapeToDateMapping }, NumberOfMonths);
    } catch (err) {
      plotGraph(
        { actual: [], forecast: [], mape: [0], mapeToDateMapping: [] },
        NumberOfMonths
      );
    }
  };

  const calculateMape = (mapeArr) => mean(compact(mapeArr)).toFixed(2);

  const calculateAndSetMap = (mapeToDateMapping) => {
    const { min, max } = chart.xAxis[0].getExtremes();
    let mapes;
    mapes = mapeToDateMapping
      .filter((x) => x.time > min && x.time < max)
      .map((x) => x.mapeVal);
    setMape(calculateMape(mapes));
  };

  const plotGraph = async (obj) => {
    const mapeArray = calculateMape(obj.mape);
    const defaultChartObj = chartOptions();

    setIsLoading(false);
    setMape(mapeArray);

    const finalChart = {
      ...defaultChartObj,
      xAxis: {
        ...defaultChartObj.xAxis,
        events: {
          afterSetExtremes() {
            calculateAndSetMap(obj.mapeToDateMapping);
          },
        },
      },
      yAxis: {
        ...defaultChartObj.yAxis,
        title: {
          ...defaultChartObj.yAxis.title,
          text: 'Demand(kW)',
        },
      },
      series: [
        {
          ...defaultChartObj.series[0],
          name: 'Actual',
          data: obj.actual,
          color: constants.color.RED,
        },
        {
          ...defaultChartObj.series[0],
          name: 'Forecast',
          data: obj.forecast,
          color: constants.color.BLUE,
        },
      ],
    };
    setChartObj(finalChart);
  };

  const generatedChartObject = (generatedChartObj) => {
    chart = generatedChartObj;
  };

  return (
    <CustomWidget
      size={12}
      id={'chrtDemandVsTimeForecast'}
      title={`Actual vs Forecast - MAPE = ${mape === 'NaN' ? '' : mape}`}
    >
      <HighChartCustomGraph
        isLoading={isLoading}
        chartObj={chartObj}
        generatedChartObject={generatedChartObject}
        chartId={'chrtDemandVsTime'}
      />
    </CustomWidget>
  );
};

export default DemandVsTime;
